export {}

const forms = document.querySelectorAll<HTMLFormElement>("form.f-newsletter")

const handleFom = (form: HTMLFormElement) => {
  const select = form.querySelector<HTMLSelectElement>(".f-newsletter__shop-select select")

  if (!select) return

  if (select.value) form.action = select.value

  select.addEventListener("change", () => {
    const {value} = select

    form.action = value
  })
}

forms.forEach((form) => {
  handleFom(form)
})
